// extracted by mini-css-extract-plugin
module.exports = {"group":"block_group__OZE2i","center":"block_center__pgHSV","right":"block_right__B5oKW"};